import { ErrorInfo } from "react";
import axios from "axios";

const SLACK_URL = process.env.REACT_APP_REPORT_SLACK_URL ?? "";

const sendSlackMessage = async (message: any) => {
  if (process.env.REACT_APP_ENV !== "production") return;
  if (!SLACK_URL) return;
  await axios.post(SLACK_URL, message, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

const createSlackMessageByError = (error: Error, info?: ErrorInfo) => {
  return {
    attachments: [
      {
        mrkdwn_in: ["text"],
        color: "danger",
        pretext: `[${process.env.REACT_APP_ENV}] Web 에러 발생`,
        author_name: "BrainyCards",
        title: error.name,
        text: error.stack,
        fields: [
          {
            title: "Component Stack",
            value: info?.componentStack,
            short: false,
          },
          {
            title: "Digest",
            value: info?.digest,
            short: true,
          },
        ],
        ts: new Date().valueOf(),
      },
    ],
  };
};

export const reportErrorToSlack = (error: Error, info: ErrorInfo) => {
  sendSlackMessage(createSlackMessageByError(error, info)).catch(() => {
    console.log("Failed to Send Error Alert");
  });
};
